// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__35ch5","productName":"Table_productName__Imk6_"};